import React, { useState, useEffect, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import Select from '../../Components/Form/Select';
import FormCustom from '../../Components/Form/FormCustom';

const RollOver = _ => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [rows, setRows] = useState([])
    const [fullRed, setFullRed] = useState([])
    const [formData, setFormData] = useState({
        p_id_customers: '',
        p_id_upline: ''
    })

    useEffect(() => {
        if (isProcessing) {
            Promise.all([
                Controllers.customers.roll_over_first_level(),
                Controllers.customers.roll_over_full_children()
            ]).then(res => {
                setRows(res[0].data)
                setFullRed(res[1].data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                })
        }
    }, [isProcessing])

    const handleInsertUpdate = ({ data }) => {
        if (!formData.p_id_customers || !formData.p_id_upline) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'Seleccionar cliente y nuevo upline',
                toast
            })

            return false
        }

        setLoadSubmit(true)
        Controllers.customers.move_user_roll_over(formData).then(res => {
            Helpers.toast.construct({ ...res, toast })
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setIsProccesing(true)
            setLoadSubmit(false)
            setFormData({
                p_id_customers: '',
                p_id_upline: ''
            })
        })
    }

    const cboCustomer = useCallback(_ => {
        let customer = rows.find(r => parseInt(r.id_customers) === parseInt(formData.p_id_customers))

        if (!customer) {
            return ''
        }

        return {
            label: customer.id_customers + ' - ' + customer.full_name_customers + ` - Puntos en nodo: (${parseInt(customer.hijo_puntos) + parseInt(customer.puntos_upline)})`,
            value: customer.id_customers,
        }
    }, [formData.p_id_customers, rows])
    
    const cboUpline = useCallback(_ => {
        let customer = fullRed.find(r => parseInt(r.id_customers) === parseInt(formData.p_id_upline))

        if (!customer) {
            return ''
        }

        return {
            label: customer.id_customers + ' - ' + customer.full_name_customers,
            value: customer.id_customers,
        }
    }, [formData.p_id_upline, fullRed])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Cambio en RollOver</span>
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder ready={!isProcessing} showLoadingAnimation rows={5}>
                    <FormCustom onSubmit={handleInsertUpdate} loadSubmit={loadSubmit}>
                        <Select
                            text="Cliente"
                            options={rows.map(r => {
                                return {
                                    label: r.id_customers + ' - ' + r.full_name_customers + ` - Puntos en nodo: (${parseInt(r.hijo_puntos)})`,
                                    value: r.id_customers,
                                    isDisabled: parseInt(r.moved_roll_over) === 1 || parseInt(r.in_period) === 0
                                }
                            })}
                            classNameParent="col-12 mb-3"
                            value={cboCustomer()}
                            onChange={e => setFormData({ ...formData, p_id_customers: e.value, p_id_upline: '' })}
                        />
                        <Select
                            text="Mover debajo de"
                            options={fullRed.map(r => {
                                return {
                                    label: r.id_customers + ' - ' + r.full_name_customers,
                                    value: r.id_customers,
                                    isDisabled: parseInt(formData.p_id_customers) === parseInt(r.id_customers)
                                }
                            })}
                            classNameParent="col-12 mb-3"
                            value={cboUpline()}
                            onChange={e => setFormData({ ...formData, p_id_upline: e.value })}
                        />
                    </FormCustom>
                </ReactPlaceholder>
            </Card.Body>
        </Card>
    </>
}

export default RollOver